import { push } from 'connected-react-router';
import {
  FILTER_CHANGE,
  CLEAR_ALL_FILTERS,
  FILTER_TAG_REMOVED,
  CLEAR_SERVICES_FILTERS_CLICKED,
} from './filtersActionsTypes';
import exploreActions from '../exploreActions';
import { PAGE_CHANGED } from '../exploreActionTypes';
import { ARENA_EXPLORE_URL } from '../../../utils/constants';

const setFilterData = data => ({
  type: FILTER_CHANGE,
  data,
});
const setClearServicesFlag = isDirty => ({
  type: CLEAR_SERVICES_FILTERS_CLICKED,
  isDirty,
});
const clearFilters = () => ({ type: CLEAR_ALL_FILTERS });
const applyNewFilter = getState => exploreActions.updateUrlWithFilters();

const onFilterApply = data => async (dispatch, getState, { withBI }) => {
  dispatch(setClearServicesFlag(false));
  await withBI({
    evid: 142,
    typeid: 1,
    filterType: Object.keys(data)[0],
    filterValue: data[Object.keys(data)[0]],
  });
  if (data) {
    await dispatch(setFilterData(data));
  }
  dispatch({ type: PAGE_CHANGED, page: 1 });
  return dispatch(applyNewFilter(getState));
};

const onFilterValueChange = data => setFilterData(data);

const onServiceClick = id => onFilterApply({ serviceIds: [id] });

const onCategoryClick = id => onFilterApply({ categoryIds: [id] });

const onClearAllFilters = () => dispatch => {
  dispatch(push(ARENA_EXPLORE_URL));
  return dispatch(clearFilters());
};

const onFilterTagRemove = tagId => (dispatch, getState) => {
  dispatch({ type: FILTER_TAG_REMOVED, tagId });
  dispatch({ type: PAGE_CHANGED, page: 1 });
  return dispatch(applyNewFilter(getState));
};

const onServiceFilterClearClicked = () => dispatch => {
  dispatch(setClearServicesFlag(true));
  return dispatch(
    setFilterData({
      categoryIds: [],
      serviceIds: [],
    }),
  );
};

export default {
  onFilterApply,
  onFilterValueChange,
  onServiceClick,
  onCategoryClick,
  onClearAllFilters,
  onFilterTagRemove,
  onServiceFilterClearClicked,
};
